import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button, IconGoogle } from "../../../components/atoms"
import { FlatpickerHourGroup, SelectGroup } from "../../../components/molecules"
import { AuthContext } from "../../../contexts/Auth/AuthContext"
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext"
import { PdfViewerContext } from "../../../contexts/PdfViewer/InterceptorContext"
import { api, convertDateTimeToPattern as dateFormat } from "../../../helpers"

export function Checkin() {
  const { applicationData } = useContext(AuthContext)
  const { setPdf } = useContext(PdfViewerContext)
  const navigate = useNavigate()

  const {
    setType,
    setShow,
    setText: setTextAlert
  } = useContext(NotificationContext)

  const [campoObrigatorioDataInicial, setcampoObrigatorioDataInicial] =
    useState<boolean>(false)
  const [campoObrigatorioDataFinal, setcampoObrigatorioDataFinal] =
    useState<boolean>(false)
  const [campoObrigatorioBarco, setcampoObrigatorioBarco] =
    useState<boolean>(false)
  const [campoObrigatorioOrigem, setcampoObrigatorioOrigem] =
    useState<boolean>(false)
  const [campoObrigatorioDestino, setcampoObrigatorioDestino] =
    useState<boolean>(false)
  const [campoObrigatorioOrdenar, setcampoObrigatorioOrdenar] =
    useState<boolean>(false)
  const [campoObrigatorioTipoPeriodo, setcampoObrigatorioTipoPeriodo] =
    useState<boolean>(false)
  const [campoObrigatorioCliente, setcampoObrigatorioCliente] =
    useState<boolean>(false)
  const [dataInicial, setDataInicial] = useState(new Date())
  const [dataFinal, setDataFinal] = useState(new Date())
  const [origem, setOrigem] = useState("0")
  const [tipoperiodo, setTipoPeriodo] = useState("Horario")
  const [ordenar, setOrdenar] = useState("CLIENTE")
  const [destino, setDestino] = useState("0")
  const [barco, setBarco] = useState("0")
  const [cliente, setCliente] = useState(
    applicationData.acesso !== "funcionario" ? applicationData.funcionario : "0"
  )

  const gravar = async () => {
    try {
      const { data: pdf } = await api.get(
        "/api/relfaturamento/" +
          cliente +
          "/" +
          barco +
          "/" +
          origem +
          "/" +
          destino +
          "/0/" +
          ordenar +
          "/" +
          dateFormat(dataInicial) +
          "/" +
          dateFormat(dataFinal) +
          "/" +
          tipoperiodo +
          "/Checkin",
        {
          responseType: "blob"
        }
      )

      if (pdf.type === "application/pdf") {
        setPdf(pdf as unknown as Blob)
        navigate("/recibo")
      }
      else {
        setType("danger")
        setTextAlert("nenhum dado encontrado no intervalo selecionado!")
        setShow(true)
      }      
    } catch {
      setType("danger")
      setTextAlert("erro na geração do relatorio!")
      setShow(true)
    }
  }

  return (
    <div>
      <h2>Check-in</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Inicial"
            messageError={
              campoObrigatorioDataInicial ? "Campo obrigatório!" : ""
            }
            value={dataInicial}
            id="data-ini"
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setDataInicial(date)
                setcampoObrigatorioDataInicial(false)
              } else {
                setcampoObrigatorioDataInicial(true)
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Final"
            messageError={campoObrigatorioDataFinal ? "Campo obrigatório!" : ""}
            value={dataFinal}
            id="data-fim"
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setDataFinal(date)
                setcampoObrigatorioDataFinal(false)
              } else {
                setcampoObrigatorioDataFinal(true)
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={tipoperiodo}
            messageError={
              campoObrigatorioTipoPeriodo ? "Campo obrigatório!" : ""
            }
            id="periodo"
            label="Tipo de periodo"
            options={[
              { text: "DATA DA RESERVA", value: "reserva.DataReserva" },
              { text: "DATA DO EMBARQUE", value: "Horario" }
            ]}
            onChange={(e) => {
              if (e.target.value !== "") {
                setTipoPeriodo(e.target.value)
                setcampoObrigatorioTipoPeriodo(false)
              }
              if (e.target.value === "") setcampoObrigatorioTipoPeriodo(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={barco}
            messageError={campoObrigatorioBarco ? "Campo obrigatório!" : ""}
            id="barco"
            label="Barco"
            options={applicationData.barcos?.map((barco: Barco) => ({
              text: barco.nome,
              value: barco.codigo
            }))}
            onChange={(e) => {
              if (e.target.value !== "") {
                setBarco(e.target.value)
                setcampoObrigatorioBarco(false)
              }
              if (e.target.value === "") setcampoObrigatorioBarco(true)
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={origem}
            messageError={campoObrigatorioOrigem ? "Campo obrigatório!" : ""}
            id="origem"
            label="Origem"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setOrigem(e.target.value)
                setcampoObrigatorioOrigem(false)
              }
              if (e.target.value === "") setcampoObrigatorioOrigem(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={destino}
            messageError={campoObrigatorioDestino ? "Campo obrigatório!" : ""}
            id="destino"
            label="Destino"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setDestino(e.target.value)
                setcampoObrigatorioDestino(false)
              }
              if (e.target.value === "") setcampoObrigatorioDestino(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={ordenar}
            messageError={campoObrigatorioOrdenar ? "Campo obrigatório!" : ""}
            id="ordenar"
            label="Ordenar por"
            options={[
              { text: "CLIENTE", value: "CLIENTE" },
              { text: "DATA DA RESERVA", value: "RESERVA.DATARESERVA" },
              { text: "DATA DO EMBARQUE", value: "HORARIO" },
              { text: "RESERVA", value: "RESERVA.CODIGO" }
            ]}
            onChange={(e) => {
              if (e.target.value !== "") {
                setOrdenar(e.target.value)
                setcampoObrigatorioOrdenar(false)
              }
              if (e.target.value === "") setcampoObrigatorioOrdenar(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3"></div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <SelectGroup
            value={cliente}
            messageError={campoObrigatorioCliente ? "Campo obrigatório!" : ""}
            readOnly={applicationData.acesso !== "funcionario"}
            id="cliente"
            label="Cliente"
            options={applicationData.clientes.map((cliente: Cliente) => ({
              text: cliente.nome,
              value: cliente.codigo
            }))}
            onChange={(e) => {
              if (
                Number(e.target.value) <= 10000 &&
                Number(e.target.value) >= 0
              ) {
                setCliente(e.target.value)
                setcampoObrigatorioCliente(false)
              }
              if (e.target.value === "") setcampoObrigatorioCliente(true)
            }}
          />
        </div>
      </div>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <Button
            appearance="success"
            onClick={() => {
              gravar()
            }}
          >
            Gerar Relatorio<IconGoogle>picture_as_pdf</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  )
}
